import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  TextWithIcon,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React from 'react';
import EditIcon from '../../_components/atoms/Icons/EditIcon';
import { numberToCurrencyFormatter } from './helper';
import SvgInfo from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Icons/Info';
import moment from 'moment';
import { formatDate } from './helper';
import { CSSProperties } from '@mui/material/styles';
import { Reconcilation } from '../../_components/organisms/ReconciliationModal';
import { VariableCost } from '../../pages/FinancialForensicsPage/types/VariableCost.types';
import {
  Document,
  FixedCost,
  Vendor,
} from '../../pages/FinancialForensicsPage/types/FixedCost.types';
import {
  cellStyles3,
  cellStyles4,
  CheckedCircle,
  Columns,
  Exclaimation,
  Processing,
  SvgDeleteButton,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { getFileIcon } from './financialForensics/reconciliationHelper';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { RowType } from '../../pages/FinancialForensicsPage/FinancialForensics.types';
import {
  emptyStoplossFeeCalculation,
  StopLossVendor,
} from '../../pages/FinancialForensicsPage/types/StopLoss.types';

export type ServiceType = {
  id: string;
  nameOfService: string;
  payer: string;
  modeOfPayment: string;
  applicable: string;
  value: number;
  unitOfFees: UnitType;
  fees: number;
  feeCalculation: FeeCalculation;
};
export type VariableServiceType = {
  value: number;
};
export type FixedPlanDataType = {
  id: string;
  nameOfVendor: string;
  services: ServiceType[];
};
export type VariablePlanDataType = {
  id: string;
  claims: string;
  services: VariableServiceType[];
  financialAdjustmentType: 'Reimbursement' | 'Recovery' | 'Rebate';
  feeCalculation: FinancialAdjustmentCalculation | VariableFeeCalculation;
};

//Employee Count Types
export type EmployeeCountBySubscriptionType = {
  subscriptionType: string;
  average: number;
};
export type EmployeeCountByPlanType = {
  planType: string;
  average: number;
};
export type EmployeeCountDataType = {
  employeesYearlyAverage: number | null;
  membersYearlyAverage: number | null;
  employeesBySubscriptionYearlyAverage: EmployeeCountBySubscriptionType[];
  employeesByPlanYearlyAverage: EmployeeCountByPlanType[];
};
export type FormatType = 'count' | 'subscription' | 'plan';
export type DottedTextProps = {
  text: string;
  icon?: React.JSX.Element;
   
  onClick?: (...args: any[]) => any;
  styles?: CSSProperties;
};
export type NoDataProps = {
   
  onClick?: (...args: any[]) => any;
};
export type FeeCalculationValue = {
  dateRange: string;
  value: number;
};
export type FeeCalculationDetail = {
  type: string;
  values: FeeCalculationValue[];
};
export type FeeCalculation = {
  id: string;
  source: string;
  option: string;
  detailsType: string;
  details: FeeCalculationDetail[];
};
export type FinancialAdjustmentCalculation = {
  id: string;
  name: string;
  option: string;
  type: string;
  vendor: string;
  notes: string;
  detailsType: string;
  details: FeeCalculationValue[][];
  rowType: 'primary' | 'secondary';
};

export type VariableFeeCalculation = {
  id: string;
  option: string;
  detailsType: string;
  details: FeeCalculationDetail[];
  rowType: 'primary' | 'secondary';
};
export type FixedMemberDataType = {};
export type ContributionEquationProps = {
  fees: number;
  stoploss: number;
  memberContribution: number;
  financialOpportunities: number;
  isFixed?: boolean;
};
export type CalculationVariables = {
  employeeCount?: number;
  monthCount?: number;
  engagedMemberCount?: number;
  yearCount?: number;
  scriptCount?: number;
  claimCount?: number;
  caseCount?: number;
  eventCount?: number;
  hourCount?: number;
  savingsAmount?: number;
  paidClaimsAmount?: number;
  billedChargesAmount?: number;
  rebateAmount?: number;
  vendorFeeAmount?: number;
  baseAmount?: number;
};

export type UnitType =
  | 'PEPM (Per Employee Subscribed Per Month)'
  | 'Per Employee Per Month'
  | 'PEPY'
  | 'Per Engaged Member Per Month'
  | 'Per Engaged Member Per Year'
  | 'Per Script'
  | 'Per Eligible Claim'
  | 'Per Case'
  | 'Per Event'
  | 'Per Hour'
  | 'Per Year'
  | 'Flat Monthly Fee'
  | 'One Time'
  | '% of Savings'
  | '% of Paid Claims'
  | '% of Billed Charges'
  | '% of Rebate'
  | '% of Fees'
  | 'Basis Points (bps)'
  | 'Per Diabetic Per Month'
  | 'Per Diabetic Per Month'
  | 'PEPM (Per Qualified Employee Per Month)'
  | 'Per Claim'
  | 'Per Net Paid Claim'
  | 'Per Processed Paper Claim'
  | 'Per Impacted Rx'
  | 'Per Record'
  | 'Per ID Card'
  | 'Postage / Shipping (As Invoiced)'
  | 'Per Seat Annual'
  | 'PMPM (Per Member Per Month)'
  | '% of Received Rebates'
  | 'As Invoiced';

export type EMployeeCount = {
  id: string;
  source: string;
  detailsType: string;
  details: FeeCalculationDetail[];
};

export type FileStatus = 'processing' | 'failed' | 'ready';

export const FeeCalculationEmptyState: FeeCalculation = {
  id: '',
  source: '',
  option: '',
  detailsType: '',
  details: [],
};

export const FinancialAdjustmentCalculationEmptyState: FinancialAdjustmentCalculation = {
  id: '',
  name: '',
  option: '',
  type: '',
  vendor: '',
  notes: '',
  detailsType: '',
  details: [],
  rowType: 'primary',
};
export const VariableFeeCalculationEmptyState: VariableFeeCalculation = {
  id: '',
  option: '',
  detailsType: '',
  details: [],
  rowType: 'primary',
};
export const EmployeeCountEmptyState: FeeCalculation = {
  id: '',
  source: '',
  option: '',
  detailsType: '',
  details: [],
};

const useStyles = makeStyles()({
  ellipsis: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '200px',
    color: patientAccessTheme.palette.text.mediumemphasis,
    '&:hover': {
      overflow: 'visible',
      whiteSpace: 'normal',
      height: 'auto',
    },
  },
  dotted: {
    fontSize: '14px',
    fontWeight: 600,
    color: patientAccessTheme.palette.primary[400],
    borderBottom: '1px dashed ' + patientAccessTheme.palette.primary[400],
    cursor: 'pointer',
  },
  icon: {
    height: '16px',
    width: '16px',
    margin: '0px 8px 0px 0px',
    '& path': {
      stroke: patientAccessTheme.palette.warning.A600,
    },
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  box: {
    border: '1px solid ' + patientAccessTheme.palette.grey[300],
    borderRadius: '0.25rem',
    padding: '0.5rem 0.75rem',
    minWidth: '140px',
    textAlign: 'center',
  },
  result: {
    border: '1px solid ' + patientAccessTheme.palette.primary[400],
  },
  underline: {
    '&:hover': {
      color: patientAccessTheme.palette.primary.main + ' !important',
      textDecoration: 'underline dashed',
      textUnderlineOffset: '0.25rem',
      cursor: 'pointer',
    },
  },
});
const commanIconStyles = {
  height: '18px',
  width: '18px',
  cursor: 'pointer',
};

export const fiscalControlDocumentsColumns: Columns[] = [
  {
    name: 'Document Name',
    align: 'left',
    width: '',
    cellStyles: cellStyles3,
    typographyStyles: {
      fontSize: '14px',
    },
  },
  {
    name: 'Status',
    align: 'left',
    width: '',
    cellStyles: cellStyles4,
  },
  {
    name: 'Used For',
    align: 'left',
    width: '',
    cellStyles: cellStyles4,
  },
  {
    name: 'Plan Period',
    align: 'left',
    width: '',
    cellStyles: cellStyles4,
  },
  {
    name: 'Upload Date',
    align: 'left',
    width: '',
    cellStyles: cellStyles4,
  },
  {
    name: '',
    align: 'left',
    width: '50px',
    cellStyles: cellStyles4,
  },
];

export const DottedText: React.FC<DottedTextProps> = ({
  text,
  icon,
  onClick,
  styles,
}) => {
  const { classes } = useStyles();
  return (
    <span className={classes.dotted} onClick={onClick} style={{ ...styles }}>
      {text}
      {icon && icon}
    </span>
  );
};
export const NoData: React.FC<NoDataProps> = ({ onClick }) => {
  const { classes } = useStyles();
  return (
    <Grid className={classes.flex} style={{ gap: '1rem' }}>
      <Typography
        fontSize="14px"
        textColor={patientAccessTheme.palette.warning.A600}
        className={classes.flex}
      >
        <SvgInfo className={classes.icon} />
        Info Needed
      </Typography>
      {' | '}
      <DottedText text={'Take Action'} onClick={onClick} />
    </Grid>
  );
};

export const ContributionEquation: React.FC<ContributionEquationProps> = ({
  fees,
  stoploss,
  memberContribution,
  financialOpportunities,
  isFixed = true,
}) => {
  const result = fees + stoploss + memberContribution - financialOpportunities;
  const { classes } = useStyles();

  const valueText = (label: string, value: number) => (
    <Typography
      fontSize="14px"
      className={classes.box}
      textColor={patientAccessTheme.palette.text.mediumemphasis}
    >
      {label}{' '}
      <strong>
        {value >= 0
          ? numberToCurrencyFormatter(value)
          : `$(${numberToCurrencyFormatter(value, false, 2)})`}
      </strong>
    </Typography>
  );

  return (
    <Grid className={classes.flex} style={{ gap: '0.5rem' }}>
      {valueText('Fees', fees)}
      {isFixed && (
        <>
          <span>+</span>
          {valueText('Stop Loss', stoploss)}
        </>
      )}
      <span>+</span>
      {valueText('Member Contribution', memberContribution)}
      <span>-</span>

      {valueText(
        isFixed ? 'Financial Opportunities' : 'Financial Adjustments',
        financialOpportunities,
      )}
      <span>=</span>
      <Typography
        fontSize="14px"
        className={`${classes.box} ${classes.result}`}
        textColor={patientAccessTheme.palette.primary[400]}
      >
        <strong>
          {result >= 0
            ? numberToCurrencyFormatter(result)
            : `$(${numberToCurrencyFormatter(result, false, 2)})`}
        </strong>
      </Typography>
    </Grid>
  );
};

export const calculateContributions = (
  data: FixedCost,
  stopLossV: Vendor[],
) => {
  let fees: number = 0;
  let stoploss: number = 0;
  let memberContribution: number = 0;
  let financialOpportunities: number = 0;

  data?.planContribution?.fees?.forEach((vendor) => {
    vendor.services.forEach((service) => {
      fees += service.fees || 0;
    });
  });

  stopLossV?.forEach((vendor) => {
    vendor.services.forEach((service) => {
      stoploss += service.fees || 0;
    });
  });

  data?.planContribution?.credits?.forEach((vendor) => {
    vendor.services.forEach((service) => {
      financialOpportunities += service.fees || 0;
    });
  });
  data?.memberContribution?.forEach((vendor) => {
    vendor.services.forEach((service) => {
      memberContribution += service.fees || 0;
    });
  });

  const totalFixedCost = Number(
    fees + memberContribution - financialOpportunities,
  );

  return {
    fees,
    stoploss,
    memberContribution,
    financialOpportunities,
    totalFixedCost,
  };
};
export const calculateVariableContributions = (data: VariableCost) => {
  let claims: number = 0;
  let memberContribution: number = 0;
  let financialOpportunities: number = 0;

  data?.planContribution?.fees?.forEach((item) => {
    claims += item.value || 0;
  });

  data?.planContribution?.rebates?.forEach((item) => {
    financialOpportunities += item.value || 0;
  });
  data?.memberContribution?.forEach((item) => {
    memberContribution += item.value || 0;
  });

  const totalVariableCost = Number(
    claims + memberContribution - financialOpportunities,
  );

  return {
    fees: claims,
    stoploss: 0,
    memberContribution,
    financialOpportunities,
    totalVariableCost,
  };
};

export const calculateFee = (
  unit: UnitType,
  amount: number,
  variables: CalculationVariables,
): number => {
  switch (unit) {
    case 'Per Employee Per Month':
      validateVariables(['employeeCount', 'monthCount'], variables);
      return amount * variables.employeeCount! * variables.monthCount!;

    case 'PEPY':
      validateVariables(['employeeCount'], variables);
      return amount * variables.employeeCount!;

    case 'Per Engaged Member Per Month':
      validateVariables(['engagedMemberCount', 'monthCount'], variables);
      return amount * variables.engagedMemberCount! * variables.monthCount!;

    case 'Per Engaged Member Per Year':
      validateVariables(['engagedMemberCount', 'yearCount'], variables);
      return amount * variables.engagedMemberCount! * variables.yearCount!;

    case 'Per Script':
      validateVariables(['scriptCount'], variables);
      return amount * variables.scriptCount!;

    case 'Per Eligible Claim':
      validateVariables(['claimCount'], variables);
      return amount * variables.claimCount!;

    case 'Per Case':
      validateVariables(['caseCount'], variables);
      return amount * variables.caseCount!;

    case 'Per Event':
      validateVariables(['eventCount'], variables);
      return amount * variables.eventCount!;

    case 'Per Hour':
      validateVariables(['hourCount'], variables);
      return amount * variables.hourCount!;

    case 'Per Year':
      validateVariables(['yearCount'], variables);
      return amount * variables.yearCount!;

    case 'Flat Monthly Fee':
      validateVariables(['monthCount'], variables);
      return amount * variables.monthCount!;

    case 'One Time':
      return amount;

    case '% of Savings':
      validateVariables(['savingsAmount'], variables);
      return (amount / 100) * variables.savingsAmount!;

    case '% of Paid Claims':
      validateVariables(['paidClaimsAmount'], variables);
      return (amount / 100) * variables.paidClaimsAmount!;

    case '% of Billed Charges':
      validateVariables(['billedChargesAmount'], variables);
      return (amount / 100) * variables.billedChargesAmount!;

    case '% of Rebate':
      validateVariables(['rebateAmount'], variables);
      return (amount / 100) * variables.rebateAmount!;

    case '% of Fees':
      validateVariables(['vendorFeeAmount'], variables);
      return (amount / 100) * variables.vendorFeeAmount!;

    case 'Basis Points (bps)':
      validateVariables(['baseAmount'], variables);
      return (amount / 10000) * variables.baseAmount!;

    default:
      throw new Error(`Unknown unit type: ${unit}`);
  }
};

const validateVariables = (
  requiredVars: Array<keyof CalculationVariables>,
  vars: CalculationVariables,
): void => {
  const missingVars = requiredVars.filter((v) => vars[v] === undefined);
  if (missingVars.length > 0) {
    throw new Error(`Missing required variables: ${missingVars.join(', ')}`);
  }
};

export const getMonthDifference = (startDateInp: any, endDateInp: any) => {
  const startDate = moment(startDateInp);
  const endDate = moment(endDateInp);

  const monthDiff = endDate.diff(startDate, 'months', true);
  return Math.ceil(monthDiff);
};

export const generateDateRanges = (
  type: string,
  startDate: string,
  endDate: string,
): string[] => {
  const ranges: string[] = [];
  const start = moment(startDate);
  const end = moment(endDate);

  if (type === 'Monthly Average' || type === 'Monthly') {
    const current = start.clone();
    while (current.isSameOrBefore(end, 'month')) {
      ranges.push(formatDate(current.format(), "MMM'YY"));
      current.add(1, 'month');
    }
  } else if (type === 'Quarterly Average' || type === 'Quarterly') {
    const current = start.clone();
    let quarterIndex = 1;

    while (current.isSameOrBefore(end)) {
      const quarterStart = current.clone();
      const quarterEnd = current.clone().add(2, 'months').endOf('month');

      // Stop if the quarter starts after endDate
      if (quarterStart.isAfter(end)) {
        break;
      }

      ranges.push(
        `Q${quarterIndex} (${quarterStart.format(
          'MMM YYYY',
        )} - ${quarterEnd.format('MMM YYYY')})`,
      );

      current.add(3, 'months');
      quarterIndex++;
    }
  } else if (type === 'Plan Year Average' || type === 'Annually') {
    const startYear = start.format('YYYY');
    const endYear = end.format('YYYY');
    ranges.push(
      startYear === endYear ? startYear : `${startYear} - ${endYear}`,
    );
  }
  return ranges;
};

export const getFixedCostColumns = (
  handleFeeClick: (
    _value: any,
    _row: any,
    _vendorID: string,
    _type: any,
  ) => void,
  handleEditVendorModal: (_value: Vendor, _row: any, _rowType: any) => void,
) => {
  const { classes } = useStyles();
  return [
    {
      name: 'Vendor Name',
      accessor: 'nameOfVendor',
      width: '',
      cell: (value: any, row: any, rowType: any) => {
        return (
          <Typography
            fontSize="14px"
            fontType="semiBold"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
          >
            {value.nameOfVendor}
            {' | '}
            <DottedText
              icon={
                <EditIcon
                  height="12px"
                  width="12px"
                  fill={patientAccessTheme.palette.primary[400]}
                  style={{ marginLeft: '0.5rem' }}
                />
              }
              onClick={() => handleEditVendorModal(value, row, rowType)}
              text={'Edit'}
            />
          </Typography>
        );
      },
    },
    {
      name: 'Service Line',
      accessor: 'nameOfService',
      width: '',
      cell: (value: any) => {
        return (
          <Typography
            fontSize="14px"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            className={classes.ellipsis}
          >
            {value}
          </Typography>
        );
      },
    },
    {
      name: 'Value',
      accessor: 'value',
      width: '',
      cell: (value: any) => {
        return (
          <Typography
            fontSize="14px"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
          >
            {value}
          </Typography>
        );
      },
    },
    {
      name: 'Unit',
      accessor: 'unitOfFees',
      width: '',
      cell: (value: any) => {
        return (
          <Typography
            fontSize="14px"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            className={classes.ellipsis}
          >
            {value}
          </Typography>
        );
      },
    },
    {
      name: 'Budgeted',
      accessor: 'fees',
      width: '',
      cell: (value: any, row: any, rowType: any, parentItem: any) => {
        return (
          <>
            {value !== 0 ? (
              <Typography
                fontSize="14px"
                textColor={patientAccessTheme.palette.text.mediumemphasis}
                className={classes.underline}
                onClick={() => {
                  handleFeeClick(
                    value,
                    row,
                    parentItem.vendorID,
                    getRowTypeFixedCost(rowType),
                  );
                }}
              >
                {numberToCurrencyFormatter(value)}
              </Typography>
            ) : (
              <NoData
                onClick={() =>
                  handleFeeClick(
                    value,
                    row,
                    parentItem.vendorID,
                    getRowTypeFixedCost(rowType),
                  )
                }
              />
            )}
          </>
        );
      },
    },
  ];
};
export const getVariableCostColumns = (
  handleOpenVariableCostEditModal: (_rowType: RowType, _rowData: any) => void,
) => {
  return [
    {
      name: 'Claims',
      accessor: 'claims',
      width: '',
      cell: (value: any, row?: any, rowType?: RowType) => {
        return (
          <Typography
            fontSize="14px"
            fontType="semiBold"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
          >
            {value.claims}
            {' | '}
            <DottedText
              icon={
                <EditIcon
                  height="12px"
                  width="12px"
                  fill={patientAccessTheme.palette.primary[400]}
                  style={{ marginLeft: '0.5rem' }}
                />
              }
              text={'Edit'}
              onClick={() =>
                rowType
                  ? handleOpenVariableCostEditModal(rowType, row)
                  : undefined
              }
            />
          </Typography>
        );
      },
    },
    {
      name: 'Budgeted',
      accessor: 'value',
      width: '',
      cell: (value: any) => {
        return (
          <>
            {value !== 0 ? (
              <Typography
                fontSize="14px"
                textColor={patientAccessTheme.palette.text.mediumemphasis}
              >
                {numberToCurrencyFormatter(value)}
              </Typography>
            ) : (
              '-'
            )}
          </>
        );
      },
    },
  ];
};

//Build Scenarios Helpers
/**
 * Converts raw fee data (Monthly, Quarterly, Annual) into array of breakdowns
 * containing feeComponents in Mongo format.
 */
export const formatFeeComponentsByType = (
  rawData: {
    Monthly?: any[];
    Quarterly?: any[];
    Annual?: any[];
  },
  type: 'Monthly' | 'Quarterly' | 'Annual',
) => {
  const rows = rawData[type];
  if (!rows || rows.length === 0) {
    return [];
  }

  const feeComponents = rows.map((row: any) => {
    const { contribution, ...valueFields } = row;
    return {
      contribution,
      values: valueFields, // keys like Q1, annual, etc.
    };
  });

  return feeComponents;
};

export const unitToRowTitleMap: Record<string, string> = {
  'PEPM (Per Employee Subscribed Per Month)': 'Monthly PEPM Fee ($)',
  'Per Employee Per Month': 'Employee Count',
  PEPY: 'Annual PEPY Fee ($)',
  'Per Engaged Member Per Month': 'Monthly Engaged Member Fee ($)',
  'Per Engaged Member Per Year': 'Annual Engaged Member Fee ($)',
  'Per Script': 'Fee Per Script ($)',
  'Per Eligible Claim': 'Fee Per Eligible Claim ($)',
  'Per Case': 'Fee Per Case ($)',
  'Per Event': 'Fee Per Event ($)',
  'Per Hour': 'Hourly Fee ($)',
  'Per Year': 'Annual Fee ($)',
  'Flat Monthly Fee': 'Flat Monthly Fee ($)',
  'One Time': 'One-Time Fee ($)',
  '% of Savings': 'Savings Amount ($)',
  '% of Paid Claims': 'Paid Claims Amount ($)',
  '% of Billed Charges': 'Billed Charges Amount ($)',
  '% of Rebate': 'Rebate Amount ($)',
  '% of Fees': 'Fees Amount ($)',
  'Basis Points (bps)': 'Basis Points Value ($)',
  'Per Diabetic Per Month': 'Monthly Fee Per Diabetic ($)',
  'Per Claim': 'Fee Per Claim ($)',
  'Per Net Paid Claim': 'Fee Per Net Paid Claim ($)',
  'Per Processed Paper Claim': 'Fee Per Processed Paper Claim ($)',
  'Per Impacted Rx': 'Fee Per Impacted Prescription ($)',
  'Per Record': 'Fee Per Record ($)',
  'Per ID Card': 'Fee Per ID Card ($)',
  'Postage / Shipping (As Invoiced)': 'Shipping & Postage (As Invoiced)',
  'Per Seat Annual': 'Annual Per Seat Fee ($)',
  'PMPM (Per Member Per Month)': 'Monthly PMPM Fee ($)',
  '% of Received Rebates': 'Received Rebates Amount ($)',
  'As Invoiced': 'As Invoiced ($)',
};

export const getRowTypeFixedCost = (row: string) => {
  switch (row) {
    case 'primary':
      return 'FEES';
    case 'secondary':
      return 'CREDITS';
    case 'tertiary':
      return 'STOPLOSS';
    case 'member':
      return 'MEMBER';
    default:
      return '';
  }
};
export const formatReconcilation = (reconciliations: any): Reconcilation[] => {
  return reconciliations.map((reconciliation: any) => ({
    _id: reconciliation?._id,
    name: reconciliation?.reconciliationName,
  }));
};

export const formatStartEndDate = (startDate: string, endDate: string) => {
  const start = moment(startDate).format('MMMM YYYY');
  const end = moment(endDate).format('MMMM YYYY');
  return `${start} - ${end}`;
};

const getStatusComponent = (status: FileStatus) => {
  switch (status) {
    case 'processing':
      return (
        <TextWithIcon
          label={
            <Typography
              fontSize="16px"
              lineHeight="22.4px"
              fontType="medium"
              textColor="#ed9b74"
            >
              In Progress
            </Typography>
          }
          endIcon={<Processing />}
          endIconLeftMargin="8px"
        />
      );
    case 'failed':
      return (
        <TextWithIcon
          label={
            <Typography
              fontSize="16px"
              lineHeight="22.4px"
              fontType="medium"
              textColor="#e8696d"
              styleProps={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '5px',
              }}
            >
              Failed
            </Typography>
          }
          endIcon={<Exclaimation />}
          endIconLeftMargin="8px"
        />
      );
    case 'ready':
      return (
        <TextWithIcon
          label={
            <Typography
              fontSize="16px"
              lineHeight="22.4px"
              fontType="medium"
              textColor="#0a433f"
            >
              Ready
            </Typography>
          }
          endIcon={<CheckedCircle />}
          endIconLeftMargin="8px"
        />
      );
    default:
      return <></>;
  }
};

export const formatDocuments = (
  documents: Document[],
   
  handleDocumentToOpen: (fileName: string, url: string) => void,
   
  handleDelete: (fileId: string) => void,
) => {
  const rowsData: any[] = [];
  const iconStyles = {
    height: '20px',
    width: '20px',
  };

  documents?.map((obj) => {
    const row = [];
    row.push(
      <Grid style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        {getFileIcon(obj.fileType, iconStyles)}
        <Typography
          fontSize="14px"
          fontType="medium"
          textColor={patientAccessTheme.palette.primary.main}
          styleProps={{
            textDecoration: 'underline dashed',
            textUnderlineOffset: '6px',
            cursor: 'pointer',
          }}
          onClick={() => handleDocumentToOpen(obj.fileName, obj.fileUrl)}
        >
          {obj.fileName}
        </Typography>
      </Grid>,
    );
    row.push(getStatusComponent(obj.status as FileStatus));
    row.push(obj.usedFor);
    row.push(formatStartEndDate(obj.startDate, obj.endDate));
    row.push(formatDate(obj.uploadedAt, 'YYYY-MM-DD'));
    row.push(
      <SvgDeleteButton
        style={commanIconStyles}
        color={patientAccessTheme.palette.status.icon}
        onClick={() => {
          handleDelete(obj._id);
        }}
      />,
    );
    rowsData.push(row);
  });
  return rowsData;
};

export const transformStoplossToVendor = (stoploss: StopLossVendor) => {
  const services = stoploss.coverage.flatMap((coverageItem) => {
    return coverageItem.subscription.map((sub) => {
      // "Specific Stop Loss Premium - Employee"
      // "Aggregate Stop Loss Premium"
      const nameOfService =
        coverageItem.coverage === 'Specific'
          ? `Specific Stop Loss Premium - ${sub.type}`
          : 'Aggregate Stop Loss Premium';

      return {
        nameOfService,
        value: sub.premiumAmount ?? '',
        unitOfFees: sub.unit ?? '',
        fees: sub.fees ?? 0,
        startDate: stoploss.policyStartYear,
        endDate: stoploss.policyEndYear,
        feeCalculation: sub.feeCalculation ?? emptyStoplossFeeCalculation(),
        // remaining serviceSchema fields with defaults
        serviceID: sub.subscriptionID,
        payer: '',
        modeOfPayment: '',
        applicable: '',
        isChosen: false,
        capFee: 0,
        flatFee: 0,
      };
    });
  });

  return {
    nameOfVendor: stoploss.name,
    vendorID: stoploss.vendorID ?? '',
    services,
  };
};
export const transformStoplossToVendors = (stoploss: StopLossVendor[]) => {
  return stoploss.map((vendor) => transformStoplossToVendor(vendor));
};
